import bg_home from 'assets/images/bg_home.png';
import bg_home_mb from 'assets/images/bg_home_mb.png';
import HeaderMenu from 'components/Header/HeaderMenu';
import RightGif from 'components/RightGif';
import { SITE } from 'config/config';
import { useEffect, useState } from 'react';
import { getAllSetting } from 'service/base';
import { twMerge } from 'tailwind-merge';
import { SETTING_KEYS } from 'utils/common/const';

const RuleFixPage = () => {
  const [dataSettings, setDataSettings] = useState([]);

  useEffect(() => {
    fetchAllSetting();
  }, []);

  const fetchAllSetting = async () => {
    try {
      const res = await getAllSetting({ site: SITE });
      setDataSettings(res?.data || []);
    } catch (error) {
      console.error('Error fetching settings:', error);
    }
  };

  return (
    <div className={twMerge(SITE, 'w-full h-full')}>
      <img
        src={bg_home_mb}
        alt="Background"
        className="fixed top-0 left-0 h-full w-full object-cover object-top md:hidden"
      />
      <img
        src={bg_home}
        alt="Background"
        className="fixed top-0 left-0 hidden h-full w-full object-cover object-top md:block"
      />
      <RightGif />
      <div className="container relative z-10">
        <HeaderMenu />
        <div className="mx-auto bg-white/95 rounded-lg border-2 border-solid border-white shadow shadow-primary p-2 md:pb-8 md:pt-4 md:px-10 w-full mt-3 md:mt-0">
          <div
            dangerouslySetInnerHTML={{
              __html: dataSettings?.find((item) => item.key === SETTING_KEYS.RULE)?.content
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default RuleFixPage;
